import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { ProcedimentoConflitoDTO } from '../../../dtos/procedimento-conflito-dto';
import { Procedimento } from '../../procedimento';
import { ProcedimentoService } from '../../procedimento.service';

@Component({
  selector: 'app-cadastro-conflito',
  templateUrl: './cadastro-conflito.component.html',
  styleUrls: ['./cadastro-conflito.component.css']
})
export class CadastroConflitoComponent implements OnInit {

  procedimento: Procedimento;

  formularioDeProcedimentoConflitante: FormGroup;

  public listaDeProcedimentos: Procedimento[] = [];

  constructor(private router: Router, private formBuilder: FormBuilder,
    private dialog: MatDialog, private procedimentoService: ProcedimentoService) {

    this.procedimento = history.state.procedimento;

    this.formularioDeProcedimentoConflitante = this.formBuilder.group({
      procedimentoConflitante: ['', [Validators.required]],
      tempoConflito: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    if (!this.procedimento) {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não será possível cadastrar o Conflito. Procedimento não encontrado.'
        }
      });
    }

    this.listarProcedimentos();
  }

  onSubmit() {
    this.save();
  }

  save() {
  
    if (!this.temConflitoCadastradoComEsteId()) {
  
      if (!this.procedimento?.conflitosDTO) {
        this.procedimento.conflitosDTO = new Array<ProcedimentoConflitoDTO>();
      }

      const procConflitante: Procedimento = this.formularioDeProcedimentoConflitante.value.procedimentoConflitante;

      const procConflito: ProcedimentoConflitoDTO = new ProcedimentoConflitoDTO();
      procConflito.idProcedimento = this.procedimento.id;
      procConflito.nomeProcedimento = this.procedimento.nome;
      procConflito.idConflito = procConflitante.id;
      procConflito.nomeConflito = procConflitante.nome;
      procConflito.tempoConflito = this.formularioDeProcedimentoConflitante.value.tempoConflito;

      this.procedimento.conflitosDTO.push(procConflito);

      this.voltarPaginaAnterior();
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Esse conflito já foi cadastrado!'
        }
      });
    }
  }

  listarProcedimentos() {
    this.procedimentoService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaDeProcedimentos = data;

        // this.configurarForm();
      }, error => {
        console.log(error);
      });
  }

  temConflitoCadastradoComEsteId(): boolean {
    let existe: boolean = false;

    if (this.procedimento && this.formularioDeProcedimentoConflitante.value) {

      if (this.procedimento.conflitosDTO) {

        for (let conflitoAtual of this.procedimento.conflitosDTO) {
          if (conflitoAtual.idConflito === this.formularioDeProcedimentoConflitante.value.procedimentoConflitante.id) {
            existe = true;
            break;
          }
        }
      }
    }

    return existe;
  }

  voltarPaginaAnterior(): void {
    this.router.navigate(['manterProcedimento'], {
      state: {
        procedimento: this.procedimento,
      }
    });
  }
}
